export const SECONDS_PER_MINUTE = 60;
export const SECONDS_PER_HOUR = 60 * SECONDS_PER_MINUTE;
export const SECONDS_PER_DAY = 24 * SECONDS_PER_HOUR;
export const SECONDS_PER_WEEK = 7 * SECONDS_PER_DAY;
export const SECONDS_PER_YEAR = 365.25 * SECONDS_PER_DAY;
export const SECONDS_PER_MONTH = SECONDS_PER_YEAR / 12;
export const SECONDS_PER_DECADE = 10 * SECONDS_PER_YEAR;

export const WORKING_HOURS_PER_YEAR = 40 * 52;
